function Datetime({input}) {

    const ar_bulan = []
            ar_bulan['01'] = 'Jan'
            ar_bulan['02'] = 'Feb'
            ar_bulan['03'] = 'Mar'
            ar_bulan['04'] = 'Apr'
            ar_bulan['05'] = 'Mei'
            ar_bulan['06'] = 'Jun'
            ar_bulan['07'] = 'Jul'
            ar_bulan['08'] = 'Agu'
            ar_bulan['09'] = 'Sep'
            ar_bulan['10'] = 'Okt'
            ar_bulan['11'] = 'Nov'
            ar_bulan['12'] = 'Des'
            
    if(""===input || undefined===input){
        return ''
    } else {
        var temp = input.split("-")
        var tanggal = temp[2]
        var bulan = ar_bulan[temp[1]]
        var tahun = temp[0]

        return tanggal+" "+bulan+" "+tahun
    }
}

export default Datetime
